module.exports = __webpack_public_path__ + "static/media/AutoCAD Plant 3D.fdc3d8e0.png";